import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { AutoComplete, MenuItem } from 'material-ui';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import styles from 'styles';
import useDebounce from 'helpers/useDebounce';
import api from 'services';

/**
 * 
 * @param {Props} props 
 */
export default function CargoNameAutoComplete({
    _preventFirstSearch = true, style = {}, menuStyle = {}, popoverProps = {}, inputStyle = {}, underlineStyle = {}, textFieldStyle = {}, ...props
}) {
    const [cargoes, setCargoes] = useState([]);
    const [item, setItem] = useState(props.item);
    const [preventFirstSearch, setPreventFirstSearch] = useState(_preventFirstSearch);

    const debouncedSearchValue = useDebounce(item.name, 500);

    useEffect(() => {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        api.getCargoNamesAutocomplete(debouncedSearchValue)
            .then((response) => {
                const _cargoes = response.data.data.map(cgo => ({
                    name: cgo.name,
                    item: (<MenuItem
                        value={cgo}
                        primaryText={cgo.name}
                        secondaryText={
                            ['admin', 'moderator'].includes(cgo.addedByRole) && 
                            <SettingsIcon 
                                style={{ 
                                    position: 'absolute', 
                                    left: -10, 
                                    marginTop: '11px',
                                    color: '#9E9E9E',
                                }} 
                            />
                        }
                        style={{ paddingLeft: '25px' }}
                    />),
                }));

                setCargoes(_cargoes);
                document.body.scrollTop += 1;
                document.body.scrollTop -= 1;
            })
            .catch(() => null);
    }, [debouncedSearchValue]);

    useEffect(() => {
        setPreventFirstSearch(!_preventFirstSearch);
    }, []);

    useEffect(() => {
        setItem(props.item);
    }, [props.item.name]);

    const onUpdateInputCargoName = (searchText) => {
        props.updateItem({
            ...item,
            name: searchText,
        });
    };

    const onNewRequestCargoes = (updateProperties) => {
        if (!updateProperties) {
            return;
        }

        const _item = _.cloneDeep(item);

        _item.name = updateProperties.name;
        _item._id = updateProperties.item.props.value._id;

        props.updateItem(_item);
        setCargoes([]);
    };

    return (
        <AutoComplete
            name={props.name || 'cargo'}
            textFieldStyle={{ ...styles.autoCompleteCSS, ...textFieldStyle }}
            hintText={props.hintText === null ? null : 'Cargo name'}
            floatingLabelText={props.hintText === null ? null : 'Cargo name'}
            searchText={item.name || ''}
            dataSource={cargoes}
            dataSourceConfig={{ text: 'name', value: 'item' }}
            onUpdateInput={onUpdateInputCargoName}
            onNewRequest={onNewRequestCargoes}
            filter={AutoComplete.noFilter}
            listStyle={styles.autoCompleteListStyle}
            inputStyle={{ fontSize: '13px', ...inputStyle }}
            style={{ fontSize: '13px', width: '100%', ...style }}
            popoverProps={{
                canAutoPosition: true,
                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                targetOrigin: { horizontal: 'left', vertical: 'top' },
                ...popoverProps,
            }}
            floatingLabelStyle={props.floatingLabelStyle}
            menuStyle={menuStyle}
            underlineStyle={underlineStyle}
        /> 
    );
}

/**
 * props
 * @typedef {Object} Props
 * @property {Item} item
 * @property {boolean} _preventFirstSearch
 * @property {Function} updateItem
 * @property {React.CSSProperties} [style]
 * @property {React.CSSProperties} [floatingLabelStyle]
 * @property {React.CSSProperties} [underlineStyle]
 * @property {string} [hintText]
 * @property {React.CSSProperties} [menuStyle]
 * @property {any} [popoverProps]
 * @property {React.CSSProperties} [inputStyle]
 * @property {string} [name]
 * @property {React.CSSProperties} [textFieldStyle]
 */


/**
 * @typedef Item
 * @property {string} _id
 * @property {string} [name]
 * @property {number} [details]
 * @property {Parent} [parent]
 */

/**
 * @typedef Parent
 * @property {{ _id?: string, name?: string }} red
*/



// WEBPACK FOOTER //
// ./app/components/common/CargoAutoComplete.jsx